import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=133ed8df&"
import script from "./Comment.vue?vue&type=script&lang=js&"
export * from "./Comment.vue?vue&type=script&lang=js&"
import style0 from "./Comment.vue?vue&type=style&index=0&id=133ed8df&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133ed8df')) {
      api.createRecord('133ed8df', component.options)
    } else {
      api.reload('133ed8df', component.options)
    }
    module.hot.accept("./Comment.vue?vue&type=template&id=133ed8df&", function () {
      api.rerender('133ed8df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Comment.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Comment.vue
// module id = 614
// module chunks = 3